(function () {
  function initSection(section) {
    var tabs = section.querySelectorAll('[data-tab-index]');
    var panels = section.querySelectorAll('[data-panel-index]');
    var prevBtn = section.querySelector('[data-arrow="prev"]');
    var nextBtn = section.querySelector('[data-arrow="next"]');
    var currentIndex = 0;
    var initialized = false;

    if (tabs.length === 0 || panels.length === 0) return;

    function showReview(index) {
      if (index < 0 || index >= tabs.length) return;

      tabs.forEach(function (tab, i) {
        var isActive = i === index;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        var isActive = i === index;
        panel.classList.toggle('active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      currentIndex = index;

      // Lazy-load images in newly active panel
      var activePanel = panels[index];
      activePanel.querySelectorAll('[data-src]').forEach(function (img) {
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
        if (img.getAttribute('data-srcset')) {
          img.srcset = img.getAttribute('data-srcset');
          img.removeAttribute('data-srcset');
        }
      });

      // Scroll active tab into view on mobile (only after user interaction)
      if (initialized) {
        var activeTab = tabs[index];
        if (activeTab && activeTab.scrollIntoView) {
          activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        showReview(i);
      });
      tab.addEventListener('keydown', function (e) {
        var newIndex;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          newIndex = (i + 1) % tabs.length;
          showReview(newIndex);
          tabs[newIndex].focus();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          newIndex = (i - 1 + tabs.length) % tabs.length;
          showReview(newIndex);
          tabs[newIndex].focus();
        }
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var newIndex = currentIndex - 1;
        if (newIndex < 0) newIndex = tabs.length - 1;
        showReview(newIndex);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var newIndex = currentIndex + 1;
        if (newIndex >= tabs.length) newIndex = 0;
        showReview(newIndex);
      });
    }

    // Read More / Read Less toggle (mobile only)
    section.querySelectorAll('[data-read-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.parentElement.querySelector('[data-review-body]');
        if (body) {
          var isExpanded = body.classList.contains('expanded');
          body.classList.toggle('expanded');
          btn.textContent = isExpanded ? 'Read more' : 'Read less';
        }
      });
    });

    // Store showReview for Shopify editor events
    section._showReview = showReview;

    showReview(0);
    initialized = true;
  }

  // Initialize all sections on page
  document.querySelectorAll('[data-couples-reviews]').forEach(initSection);

  // Shopify theme editor: re-initialize when section is loaded/reloaded
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-couples-reviews]');
    if (section) initSection(section);
  });

  // Shopify theme editor: switch to selected block's tab
  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target.closest('[data-couples-reviews]');
    if (!section || !section._showReview) return;
    var panel = event.target.closest('[data-panel-index]');
    if (panel) {
      section._showReview(parseInt(panel.getAttribute('data-panel-index'), 10));
    }
  });
})();
